export const appointmentServices = [
  'Development Services (Web, Mobile, Enterprise Systems)',
  'Public Sector & LGU Systems (Real Property Tax, BPLS, Smart Governance)',
  'Healthcare & EMR Systems (Hospital Info, PhilHealth Integration)',
  'On-Demand Delivery & Fleet Logistics Platforms',
  'Web3 & Blockchain Engineering (Smart Contracts, Tokenomics, Ledger Auditing)',
  'Marketing & Brand Support (Identity, Video, 3D Modeling)',
  'Lead Generation & Sales Support (Prospecting, Appointments)',
  'Admin & Operation Support (Inbox, Calendar, Reporting)',
  'Custom Enterprise RFP & Tech Strategy Consultation',
];
